define([
	"./_Flip",
	"./PluginFactory"
], function(_Flip, PluginFactory) {

	return PluginFactory.declare(_Flip, {
		iconClass: "csiActionIcon svgIconFlipVertical",
		pluginName: "flipVertical",
		title: "CanvasFlipVertical"
	});
});
